
import { Injectable } from '@angular/core';
import { HttpHelperService } from './http-helper.service';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import { HttpAuthHelperService } from './http-auth-helper.service';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  private baseUrl = environment.endpoint + '/user-settings';

  constructor(
    private httpHelperService: HttpAuthHelperService,
  ) {
  }

  // GET /me - Get current user settings
  async getMe() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}/me`
      );
      if (result && result.body && result.body.response) {
        resolve(result.body.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  // POST /save - Save user settings
  async save(userSettings: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/save`,
        { ...userSettings }
      );
      if (result && result.body && result.body.response) {
        resolve(result.body.response);
      } else {
        reject('API ERROR');
      }
    });
  }
  async getSettingsInBatch(userUUIDs: string[], properties: string[] = []) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/batch`,
        { userUUIDs, properties }
      );
      if (result && result.body && result.body.response) {
        resolve(result.body.response.items);
      } else {
        reject('API ERROR');
      }
    });
  }

  // // POST /save - Update specific settings fields
  // async updatePartial(partialSettings: any) {
  //   return new Promise<any>(async (resolve, reject) => {
  //     const result: any = await this.httpHelperService.requestPromise(
  //       'POST',
  //       `${this.baseUrl}/save`,
  //       { ...partialSettings }
  //     );
  //     if (result && result.response) {
  //       resolve(result.response);
  //     } else {
  //       reject('API ERROR');
  //     }
  //   });
  // }
};
